<h1 mat-dialog-title>Confirm action</h1>
<mat-dialog-content>
    <h3>{{data.dialogText}}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="warn" mat-button [mat-dialog-close]="true">Confirm</button>
</mat-dialog-actions>